import LzMsg from '@/components/common/LzMsg';
import { Servlets } from '@/service';
import { Button, Input } from '@alifd/next';
import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';

function SmsTest(props) {
  const { pageDisable, smsContent, templateId } = props;
  const [receivePhoneNum, setReceivePhoneNum] = useState('');
  const [messageSign, setMessageSign] = useState('');// 短信签名
  // 发送测试短信
  const sendTestSms = (mobile) => {
    const params = {
      channelType: 1, // 短信类型 0-营销短信，1-关怀短信
      mobile,
      // smsAccount: v.smsAccount,
      sign: messageSign,
      templateId: templateId,
      // templateParam: v.templateId,
      replace: 1,
      fullContent: smsContent,
    };
      Servlets('sendTestsms', params).then((res) => {
      if (res.success) {
        LzMsg.success('发送成功')
      }else {
        LzMsg.error(res.resp_msg);
      }
    }).catch((e) => {
      console.log(e);
      LzMsg.error(e.message);
    });
  };
  // 获取短信签名
  const getSmsSign = () => {
    Servlets('getTitle', {}).then((res: { data: string }) => {
      const { shopName } = res.data;
      Servlets('getSmssign', { shopName }).then((res: any) => {
        if (res.success) {
          setMessageSign(res.data);
        }
      });
    });
  };
  useEffect(()=>{
    getSmsSign(); // 获取短信签名
  },[])
  return (
    <div>
      <div className={styles['input-box']}>
        <div className={styles['title-box']}>
          短信测试：
        </div>
        <div>
          <Input
            onChange={(value) => {
              setReceivePhoneNum(value.replace(/[^\d.]|^\./g, ''));
            }}
            disabled={pageDisable}
            value={receivePhoneNum}
            style={{ width: '496px', borderRadius: '2px' }}
          />
          <Button
            type="primary"
            style={{ marginLeft: '10px',borderRadius: '5px' }}
            onClick={() => {
              const reg = /^1\d{10}$/;
              const flag = reg.test(receivePhoneNum);
              if (!smsContent) {
                LzMsg.error('短信内容不能为空！');
              } else if (!receivePhoneNum) {
                LzMsg.error('测试手机号不能为空！');
              } else if (!flag) {
                LzMsg.error('请正确填写测试手机号！');
              } else {
                sendTestSms(receivePhoneNum);
              }
            }}
            disabled={pageDisable}
          >
            发送测试
          </Button>
        {/* <Button style={{paddingLeft:"10px"}} text type="primary" onClick={() => setPhoneModule(true)}>修改测试手机号</Button> */}
        {/* <Button
          type="primary"
          text
          style={{ marginLeft: '10px' }}
          disabled={pageDisable}
        >测试记录
        </Button> */}
        </div>
      </div>
      <div className={styles['tips-box']}>
        <div className={styles['gray-box']}>
          测试发送的链接/变量均为测试链接/变量，仅做示意，无法正常使用；实际投放时，将替换成正确的内容
        </div>
        <div className={styles['red-box']}>
          受官方频控影响，每个手机号每天只能测试一次，多个测试手机号总共不要超过5条
        </div>
        <div className={styles['red-box']}>
          自定义短信模板审核通过后方可发送测试
        </div>
      </div>
    </div>
  );
}

export default SmsTest;
